<template>
    <div class="chart">
        <apexchart ref="chart" type="bar" height="380" :options="chartOptions" :series="series"></apexchart>
    </div>
</template>

<script>
  import VueApexCharts from 'vue-apexcharts'
  export default {
    name: 'B3dikelola',
    components: {
      apexchart: VueApexCharts,
    },
    props: {
        models: {
            type: Object,
            required: true,
        },
    },
    data: function () {
      return {
        series: [{
          data: []
        }],
        chartOptions: {
          chart: {
            type: 'bar',
            height: 380,
            events: {
              mounted: (chart) => {
                chart.windowResizeHandler();
              }
            }
          },
          xaxis: {
            categories: []
          },
          title: {
            text: 'Sampah B3/LB3 yang Dikelola Pihak Ketiga, tahun '+ this.models.year,
          },
          plotOptions: {
            bar: {
              distributed: true,
              //horizontal: true
            },
          },
          legend: {
            show: false
          }
        }
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
        getData() {
            const _ = this;
            _.$axios.get('DashboardRumahTangga/JumlahSampahDikelolaPihak3', {
                    params: {
                      years: _.models.year,
                    }
                })
                .then(res => {
                    let data = res.data.data;
                    _.series = [{
                      name: "Terlayani",
                      data: []
                    }];
                    _.chartOptions.xaxis.categories = [];
                    data.forEach((v) => {
                      _.series[0].name = v.namaPihak3;
                      _.series[0].data.push(v.beratTonase);
                      _.chartOptions.xaxis.categories.push(v.namaPihak3);
                    });

                    _.$nextTick(() => {
                      _.$refs.chart.init();
                    });
                })
        },
    },
    watch: {
      models: {
        handler(newVal, oldVal) {
          this.getData();
          this.chartOptions.title.text = 'Sampah B3/LB3 yang Dikelola Pihak Ketiga, tahun '+ this.models.year;
        },
        deep: true,
      },
    },
  }
</script>